import { get,postP,uploadOther,put,deleteP,upload,deletePost } from '@/utils/axios'

export default {
    

    ACCOUNT_LOGIN(data){
        return postP('/OAuth/SignWebPhone',data)
    },
    Send_Code(data){
        return get('/OAuth/SendCode',data)
    },
    GetMembersAllow(data){
        return get('/Member/GetMembersAllow/gender',data)
    },
    GetLianTaDouPricesAllow(data){
        return get('/Member/GetLianTaDouPricesAllow',data)
    },
    GetVipEquity(data){
        return get('/vipEquity/GetVipEquity',data)
    },


    WeChatPay(data){
        return postP('/WeChat/WebUnifiedorder',data)
    },
   
    JssdkUnifiedorder(data){
        return postP('/WeChat/JssdkUnifiedorder',data)
    },
    AliPay(data){
        return postP('/AliPay/WapAliPay',data)
    },
    
    GetOpenId(data){
        return get('/WeChat/GetOpenId/'+data)
    },
    GetImageCode(data){
        return get('/OAuth/GetImageCode',data)
    },
}